// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__21PX8","buttons":"SendReceipts_buttons__2eOvA","email":"SendReceipts_email__3AL-q","bookApptTitle":"SendReceipts_bookApptTitle__36d5F"};